export default __webpack_public_path__ + "static/media/slide_5.f76ec3a4.webp";